import React from "react";
import { Link } from "react-router-dom";
import {
  Eye,
  Users,
  Building2,
  Target,
  Mail,
  Zap,
  Activity,
  ShieldCheck,
  ArrowRight,
  ArrowUpRight,
} from "lucide-react";
import { features } from "../mock";

const iconMap = {
  Eye,
  Users,
  Building2,
  Target,
  Mail,
  Zap,
  Activity,
  ShieldCheck,
};

export default function Features() {
  return (
    <section id="platform" className="relative border-t border-slate-200/80 bg-slate-50/40 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            The Platform
          </p>
          <h2 className="mx-auto mt-3 max-w-3xl text-4xl font-medium tracking-tight text-[#1e1b4b] sm:text-5xl">
            Find Fresh Faces <span className="text-slate-400">Faster.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-slate-600">
            Eight integrated modules — identity, intent, audiences, and
            activation — pulling from one authoritative graph. No silos. No
            stale data. No spreadsheets in between.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => {
            const Icon = iconMap[f.icon];
            return (
              <Link
                key={f.slug}
                to={`/solutions/${f.slug}`}
                className="group relative flex flex-col bg-white p-6 transition-colors hover:bg-slate-50/70"
              >
                <div className="flex items-start justify-between">
                  <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-600 transition-colors group-hover:bg-[#1e1b4b] group-hover:text-white">
                    <Icon className="h-4 w-4" />
                  </div>
                  {f.tag && (
                    <span className="rounded-full bg-[#d4af37]/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#7a4f00]">
                      {f.tag}
                    </span>
                  )}
                </div>

                <h3 className="mt-5 text-lg font-semibold text-[#1e1b4b]">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  {f.desc}
                </p>

                <div className="mt-6 flex items-end justify-between border-t border-slate-100 pt-4">
                  <div>
                    <span className="text-xl font-medium text-[#1e1b4b]">
                      {f.metric}
                    </span>
                    <span className="ml-1.5 text-[10px] font-medium uppercase tracking-wider text-slate-500">
                      {f.metricLabel}
                    </span>
                  </div>
                  <ArrowUpRight className="h-4 w-4 text-slate-400 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#d4af37]" />
                </div>
              </Link>
            );
          })}

          {/* See all card */}
          <Link
            to="/demo"
            className="group relative flex flex-col items-start justify-between bg-[#1e1b4b] p-6 text-white transition-colors hover:bg-[#0a1828]"
          >
            <div>
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 text-[#d4af37]">
                <ArrowRight className="h-4 w-4" />
              </div>
              <h3 className="mt-5 text-lg font-semibold">See All Features</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/70">
                Compare features and find the right plan for your team.
              </p>
            </div>
            <div className="mt-6 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-[#d4af37]">
              Explore
              <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
